<template lang="pug">
    v-container(grid-list-md v-if="detail")
        v-layout(wrap)
            v-flex(lg6 md6 xs12)
                v-text-field(dense v-model="account" label="Rekening Sumber" readonly)
            v-flex(lg4 md4 xs12)
                v-text-field(dense v-model="detail.noSts" label="No STS" readonly )
        v-layout(wrap)
            v-flex(lg11 md11 xs12)
                v-text-field(dense v-model="detail.customerAddress" label="Alamat" readonly)
        v-layout(wrap)
            v-flex(lg2 md2 xs12)
                v-text-field(dense v-model="detail.handphone" label="Handphone" readonly )
            v-flex(lg2 md2 xs12)
                v-text-field(dense v-model="detail.nop" label="NOP" readonly )
            v-flex(lg3 md3 xs12)
                v-text-field(dense v-model="detail.anggaran" label="Anggaran" readonly)
            v-flex(lg3 md3 xs12)
                v-text-field(dense v-model="detail.amount" label="Nominal" readonly)
        div(justify-center style="text-align: center;" class="ma-2 menu-btn")
            v-btn(class="mx-1" @click="doBack") Kembali
                v-icon mdi-arrow-left-circle
</template>
<script>
export default {
    name: "FPhriContent",
    props: ["phri"],
    data() {
        return {
            detail: null
        }
    },
    watch: {
        phri(val){
            this.doInit(val);
        }
    },
    computed: {
        account() {
            return this.detail.account ? (this.detail.account + 
                (this.detail.customerName ? (" - " + this.detail.customerName) : "")) : "";
        },
    },
    mounted() {
        this.doInit(this.phri);
    },
    methods: {
        doInit(values){
            this.detail = values ? values : null;
        },
        doBack(){
            this.$emit("back");
        }
    },
}
</script>